import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

import { STEP_STATE, WIZARD_PROGRESS } from '../../lib/constants';

const StatusBadge = ({
  step,
  isFirstStep,
  isLastStep,
  onExpandStep,
  onCollapseStep,
  onActivateStep
}) => {
  const { status, state_status } = step;
  const expanded = state_status === STEP_STATE.EXPANDED;
  const hasMultiple = Array.isArray(step.substeps) && step.substeps.length > 1;
  const isDone = status === WIZARD_PROGRESS.COMPLETED || status === WIZARD_PROGRESS.CONFIRMED;
  const isInProgress = status === WIZARD_PROGRESS.IN_PROGRESS;
  return (
    <>
      {(!isLastStep || (isLastStep && expanded && step.substeps.length > 1)) && (
        <div className="absolute left-3 top-6 h-8 w-px bg-neutral-200" />
      )}
      {isFirstStep && <div className="absolute bottom-6 left-3 z-[1] h-3 w-px bg-neutral-200" />}
      <div
        onClick={() => onActivateStep(step.code)}
        className={cn('relative z-10 flex-shrink-0 cursor-pointer items-center')}>
        <div
          className={cn(
            'flex h-6 w-6 items-center justify-center rounded-full border border-solid border-neutral-400 bg-white',
            isInProgress && 'border-warning-500 text-warning-500',
            isDone && 'border-none bg-success-500',
            expanded ? (isDone ? 'text-success-500' : 'text-primary-500') : 'text-neutral-500',
            step.active && !isDone && !isInProgress && 'border-primary-500 ring-4 ring-primary-100',
            step.active && isDone && 'ring-4 ring-success-100',
            step.active && isInProgress && 'ring-4 ring-warning-100'
          )}>
          {isDone ? (
            <Icon icon="check-linear" color="neutral" shade={50} />
          ) : (
            <div
              className={cn(
                'h-2.5 w-2.5 rounded-full border border-solid border-neutral-700 bg-white',
                isInProgress && 'border-warning-600 bg-warning-600',
                step.active && !isInProgress && 'border-primary-500 bg-primary-500'
              )}
            />
          )}
        </div>
      </div>
      <div onClick={() => onActivateStep(step.code)} className="min-w-0 flex-1 cursor-pointer">
        <h3
          className={cn(
            'text-sm font-medium leading-snug text-neutral-900',
            step.active && 'font-semibold text-primary-500',
            isDone && step.active && 'text-success-500',
            isInProgress && step.active && 'text-warning-500'
          )}>
          {step.name}
        </h3>
      </div>
      <div>
        {hasMultiple && (
          <Icon
            className="cursor-pointer"
            onClick={() => {
              status === STEP_STATE.EXPANDED ? onCollapseStep(step.code) : onExpandStep(step.code);
            }}
            color="neutral"
            shade={700}
            icon={
              state_status === STEP_STATE.COLLAPSED
                ? 'chevron-down-2-linear'
                : 'chevron-up-2-linear'
            }
          />
        )}
      </div>
    </>
  );
};

export default StatusBadge;
